import React, { useEffect, useState } from "react";

// ✅ Custom hook to detect vertical scrollbar
export function useHasVerticalScroll() {
    const [hasScroll, setHasScroll] = useState(false);

    useEffect(() => {
        const checkScroll = () => {
            setHasScroll(
                document.documentElement.scrollHeight >
                document.documentElement.clientHeight
            );
        };

        checkScroll(); // run once on mount
        window.addEventListener("resize", checkScroll);
        window.addEventListener("scroll", checkScroll);

        return () => {
            window.removeEventListener("resize", checkScroll);
            window.removeEventListener("scroll", checkScroll);
        };
    }, []);

    return hasScroll;
}